import { c as _c } from "react/compiler-runtime";
import type { Address } from 'viem';
import { parseApiAsset } from '@morpho-org/dapp-core';
import { useQuery } from '@tanstack/react-query';
import { toVaultV2ActionPanelData } from '@/components/VaultPage/VaultV2/VaultV2SimpleActionPanel/vaultV2ActionPanel.mapper';
import { useWeb3Context } from '@/contexts/Web3Context';
import { orpc } from '@/lib/orpc/client';

/**
 * Which procedure a vault V2 recap reads: the one behind the dialog it was opened from, so the
 * recap shares its cache and its failure modes. `positionManager` survives spot APY and rewards
 * outages, with the APY left null.
 */
export type VaultV2RecapSource = 'actionPanel' | 'positionManager';

/** The vault and asset a vault V2 recap shows; both undefined when they can't be read. */
export const useVaultV2RecapData = t0 => {
  const $ = _c(11);
  const {
    vaultAddress,
    source: t1
  } = t0;
  const source = t1 === undefined ? "actionPanel" : t1;
  const {
    targetChainId
  } = useWeb3Context();
  const input = {
    chainId: targetChainId,
    address: vaultAddress
  };
  const actionPanel = useQuery({
    ...orpc.vaultV2.actionPanel.queryOptions({
      input
    }),
    enabled: source === "actionPanel"
  });
  const t2 = orpc.vaultV2.positionManager.queryOptions({
    input
  });
  const t3 = source === "positionManager";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = {
      ...t2,
      enabled: t3
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const positionManager = useQuery(t4);
  const {
    data,
    isLoading
  } = source === "positionManager" ? positionManager : actionPanel;
  let t5;
  let vaultV2;
  if ($[3] !== data || $[4] !== targetChainId) {
    vaultV2 = data ? toVaultV2ActionPanelData(data, targetChainId) ?? undefined : undefined;
    t5 = parseApiAsset(vaultV2?.asset);
    $[3] = data;
    $[4] = targetChainId;
    $[5] = t5;
    $[6] = vaultV2;
  } else {
    t5 = $[5];
    vaultV2 = $[6];
  }
  const vaultAsset = t5;
  let t6;
  if ($[7] !== isLoading || $[8] !== vaultAsset || $[9] !== vaultV2) {
    t6 = {
      vaultV2,
      vaultAsset,
      loading: isLoading
    };
    $[7] = isLoading;
    $[8] = vaultAsset;
    $[9] = vaultV2;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};